export class SolicitacaoDTO {

    id: number;
    nome: string;
    cpf: string;      
    emailSolicitante: string;  
    telefone: number;
    numeroProcesso: string;
    codigoDaVara: number;
    nomeDaVara: string;
    emailDaVara: string;
    codigoDaComarca: number;
    nomeDaComarca: string;
    detalheSolicitacao: string;  
    cep: string;
    complemento: string;
    bairro: string;
    uf: string;
    numero: string;
    rua: string;
    cidade: string;
    enderecoSigiloso: boolean;
    
    constructor() {
    }
}